import { shallowRef, ref } from 'vue';
import { AdminAuth } from '@nsftx/seven-client-sdk-admin';

export const keycloakInstance = shallowRef(null);

let initialized = false;
const accessToken = ref('');

export const initializeKeyloak = async () =>
  new Promise((resolve) => {
    keycloakInstance.value = new AdminAuth({
      environment: appEnvironment,
      app: {
        displayId: 'sportsbookAdmin',
      },
      debug: true,
      events: {
        onTokenUpdated: (token) => {
          accessToken.value = token;

          if (!initialized) {
            initialized = true;
            resolve();
          }
        },
      },
    });

    keycloakInstance.value.initialize();
  });

export const getAccessToken = () => accessToken.value;
export const accessTokenRef = accessToken;
